export enum LOCAL_STORAGE_KEYS {
  NOTIFICATION_COUNT = 'notification-count',
}
